import MenuItem from "@material-ui/core/MenuItem";
import PropTypes from "prop-types";
import Text from "shared/components/data-display/mui/Text";
import VersionsListIcon from "shared/components/utils/icons/VersionsList";
import { TextWrapper } from "./AboutMenuProfileItem.styles";

const AboutMenuProfileItem = (props) => {
    return (
        <MenuItem onClick={props.onClick}>
            <VersionsListIcon />
            <TextWrapper>
                <Text variant="medium">Version</Text>
            </TextWrapper>
        </MenuItem>
    );
};

AboutMenuProfileItem.propTypes = {
    onClick: PropTypes.func,
};

export default AboutMenuProfileItem;
